import { GlDisclosureDropdownItem, GlModalDirective } from '../../../../../../node_modules/@gitlab/ui/src/index.js?vue3';
import { TYPE_ISSUE } from '~/issues/constants';
import { __ } from '~/locale';
import CsvExportModal from './csv_export_modal.vue?vue3';
import CsvImportModal from './csv_import_modal.vue?vue3';
export default {
    name: 'CsvImportExportButtons',
    components: {
        GlDisclosureDropdownItem,
        CsvExportModal,
        CsvImportModal
    },
    directives: {
        GlModal: GlModalDirective
    },
    inject: {
        issuableType: {
            default: TYPE_ISSUE
        },
        showExportButton: {
            default: false
        },
        showImportButton: {
            default: false
        },
        canEdit: {
            default: false
        },
        projectImportJiraPath: {
            default: null
        }
    },
    props: {
        exportVariables: {
            type: Object,
            required: false,
            default: ()=>({})
        },
        issuableCount: {
            type: Number,
            required: false,
            default: undefined
        }
    },
    data () {
        return {
            dropdownItems: {
                exportAsCSV: {
                    text: __('Export as CSV')
                },
                importCSV: {
                    text: __('Import CSV')
                },
                importFromJIRA: {
                    text: __('Import from Jira'),
                    href: this.projectImportJiraPath
                }
            }
        };
    },
    computed: {
        exportModalId () {
            return `${this.issuableType}-export-modal`;
        },
        importModalId () {
            return `${this.issuableType}-import-modal`;
        }
    }
};
